import React from "react";
import { motion } from "framer-motion";

import aara from "../../accests/common/araa.jpeg"
import sigi from "../../accests/sigiri/sigiri (5).jpeg"
import kandd from "../../accests/kan/kan (1).jpeg"
import nuw from "../../accests/kan/kan (9).jpeg"
import el from "../../accests/ella/rawana.jpeg"
import udaa from "../../accests/udawalawa/u2.jpeg"
import fish from "../../accests/bentota/ben (2).jpeg"
import a from "../../accests/common/ara.jpeg"
import ac from "../../accests/common/galle.jpg"


const dayHighlights = [
    {
        day: "Day 1 – Arrival",
        title: "Transfer to Negombo",
        desc: "Upon arrival at Colombo International Airport, you will be warmly welcomed and transferred to Negombo, famous for its stunning beaches, vibrant fish markets, and colonial heritage. Enjoy a leisurely evening at your hotel or stroll along the golden shores.",
        img: aara,
    },
    {
        day: "Day 2 & 3 – Sigiriya & Dambulla",
        title: "Lion Rock, Pinnawala & Cave Temple",
        desc: "Drive to Sigiriya, home to the legendary Sigiriya Rock Fortress. Visit Pineapple Garden and Pinnawala Elephant Orphanage. Explore Dambulla Cave Temple and enjoy an authentic Sri Lankan village tour with bullock cart ride and local meal.",
        img: sigi,
    },
    {
        day: "Day 4 – Kandy",
        title: "Cultural Capital & Temple of the Tooth",
        desc: "Visit the Herbal & Spice Garden in Matale, Matale Hindu Temple, then arrive in Kandy. Witness a spectacular Cultural Dance Show and visit the Temple of the Tooth Relic, one of the world’s most sacred Buddhist sites.",
        img: kandd,
    },
    {
        day: "Day 5 – Nuwara Eliya",
        title: "Botanical Gardens & Tea Country",
        desc: "Morning visit to Peradeniya Royal Botanical Gardens. Travel through tea plantations, visit a tea factory, pluck fresh tea leaves, and enjoy a cup of Ceylon tea. Explore Nuwara Eliya, also known as 'Little England', and stop at waterfalls en route.",
        img: nuw,
    },
    {
        day: "Day 6 – Ella",
        title: "Scenic Train Journey & Little Adam’s Peak",
        desc: "Board the scenic train from Nanu Oya to Ella. Hike Little Adam’s Peak for panoramic views, visit the Nine Arch Bridge, and take part in an authentic Sri Lankan cooking class.",
        img: el,
    },
    {
        day: "Day 7 – Udawalawe National Park",
        title: "Elephant Transit Home & Safari",
        desc: "Drive to Udawalawe, stopping at Ravana Falls. Visit Elephant Transit Home, then enjoy a jeep safari in Udawalawe National Park, home to wild elephants, leopards, and diverse birds. Overnight at a wildlife lodge.",
        img: udaa,
    },
    {
        day: "Day 8 & 9 – Bentota",
        title: "Beaches, Stilt Fishing & Galle Fort",
        desc: "Explore Weligama Fish Market, stilt fishermen in Koggala, Galle Dutch Fort, and a turtle hatchery. Spend your final days relaxing on Bentota’s pristine beaches, soaking in the sun and ocean breeze.",
        img: fish,
    },
    {
        day: "Day 10 – Departure",
        title: "Transfer to Colombo Airport",
        desc: "After a relaxing beachside retreat, transfer back to Colombo Airport for your departure, taking home unforgettable memories of this diverse and captivating island.",
        img: a,
    },
];

const info = [
    { label: "Trip Length", value: "9 Nights / 10 Days" },
    { label: "Language", value: "English" },
    { label: "Best Time to Travel", value: "Year-round" },
    { label: "Transfers", value: "Hotel – Tour Attractions – Hotel" },
];

const inclusions = [
    "Private air-conditioned vehicle (Car/Van/Mini Coach/Luxury Bus)",
    "Comfortable accommodation on a Half Board basis",
    "English speaking professional guides",
    "Entrance fees for all UNESCO Heritage sites",
    "Safari Jeep & other tour activities",
    "Unlimited bottled water throughout the tour",
    "All government taxes & tariffs included",
];

const exclusions = [
    "Additional meals & beverages beyond the meal plan",
    "Visa and flight bookings",
    "Personal expenses, tips, and portage",
];

const travelTips = [
    "Not suitable for guests with reduced mobility",
    "Dress Code: Modest attire required for temple visits (no exposed shoulders or knees)",
    "Wear cotton clothes, bring your camera, and stay hydrated",
    "Hat, Passport, extra cash, Bathing gear, Sunblock, insect repellent, Sunglasses, Comfortable clothing",
];

export default function EpicSriLankaTour() {
    return (

        <div className="overflow-x-hidden">

            <section className="relative h-[70vh] w-full overflow-hidden lg:mt-20">
                <img
                    src={ac}
                    alt="Epic Sri Lanka Tour"
                    className="w-full h-full object-cover"
                />
                <div
                    className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/40 flex flex-col items-center justify-center text-center px-4">
                    <h1 className="text-4xl md:text-5xl text-white font-bold mb-3">
                        Epic Sri Lanka Tour
                    </h1>
                    <p className="text-lg md:text-xl text-white/90 max-w-3xl">
                        9-Night private handcrafted journey through Sri Lanka’s cultural and natural wonders
                    </p>
                </div>
            </section>

            <div className="max-w-7xl mx-auto px-4 py-16 space-y-16">

            {/* Day Highlights */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="space-y-12">
                {dayHighlights.map((item, idx) => (
                    <motion.div
                        key={idx}
                        initial={{opacity: 0, x: idx % 2 === 0 ? -50 : 50}}
                        whileInView={{opacity: 1, x: 0}}
                        viewport={{once: true}}
                        className={`md:flex md:items-center md:space-x-8 bg-white shadow-lg rounded-xl overflow-hidden ${
                            idx % 2 === 1 ? "md:flex-row-reverse" : ""
                        }`}
                    >
                        <img
                            src={item.img}
                            alt={item.title}
                            className="md:w-1/2 h-64 object-cover"
                        />
                        <div className="p-6 md:w-1/2">
                            <h3 className="text-2xl font-bold mb-2">{item.day}</h3>
                            <h4 className="text-xl font-semibold mb-4">{item.title}</h4>
                            <p className="text-gray-700">{item.desc}</p>
                        </div>
                    </motion.div>
                ))}
            </section>

            {/* Info Section */}
            <section
                className="bg-yellow-50 p-8 rounded-xl shadow-lg grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {info.map((item, idx) => (
                    <div key={idx} className="text-center">
                        <h4 className="text-lg font-semibold">{item.label}</h4>
                        <p className="text-gray-700">{item.value}</p>
                    </div>
                ))}
            </section>

            {/* Inclusions & Exclusions */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="grid md:grid-cols-2 gap-8">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="text-2xl font-bold mb-4">Tour Inclusions</h3>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        {inclusions.map((i, idx) => (
                            <li key={idx}>{i}</li>
                        ))}
                    </ul>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-lg">
                    <h3 className="text-2xl font-bold mb-4">Tour Exclusions</h3>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        {exclusions.map((e, idx) => (
                            <li key={idx}>{e}</li>
                        ))}
                    </ul>
                </div>
            </section>

            {/* Travel Tips */}
            <section data-aos="fade-up"
                     data-aos-duration="3000" className="bg-gray-50 p-6 rounded-xl shadow-lg">
                <h3 className="text-2xl font-bold mb-4">Travel Tips</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                    {travelTips.map((tip, idx) => (
                        <li key={idx}>{tip}</li>
                    ))}
                </ul>
            </section>

            {/* WhatsApp CTA */}
            <motion.div
                initial={{opacity: 0, y: 40}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 0.8}}
                className="mt-14 text-center"
            >
                <motion.a
                    whileHover={{scale: 1.08}}
                    whileTap={{scale: 0.95}}
                    href="https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%20Epic%20Sri%20Lanka%20Tour.%20Please%20share%20availability%20and%20pricing.%20Thank%20you."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-14 py-4 bg-green-600 text-white font-semibold text-lg rounded-full shadow-xl hover:bg-green-500 transition-all duration-300"
                >
                    Book This Tour
                </motion.a>
                <p className="mt-4 text-sm text-gray-600">
                    💬 Instant WhatsApp Support • 🏞️ Full Sri Lanka Experience • 🚙 Comfortable Private Transport
                </p>
            </motion.div>
        </div>
        </div>
    );
}
